export const styles = (theme) => ({
  spacerTop: {
    marginTop: "1.5rem",
  },
});
